import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from "@angular/router";
import { AuthGuard } from "../app/shared/services";

const routes: Routes = [
  { path: "", redirectTo: "sieni", pathMatch: "full" },
  {
    path: "sieni",
    loadChildren: "./pages/redirect/redirect.module#RedirectModule",
    canActivate: [AuthGuard]
  },
  { path: "auth", loadChildren: "./pages/auth/auth.module#AuthModule" }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
